import { FC } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from '../../../app/store'
import { useLocale } from '../../../hooks/useLocale'
import OnboardingFooter from '../components/OnboardingFooter'
import OnboardingHeader from '../components/OnboardingHeader'
import OnboardingContainer from '../OnboardingContainer'
import TitleDescription from './TitleDescription'

const InfoQuestion: FC<any> = ({ index, onSubmit, submitting = false }) => {
  const { t } = useLocale()
  const onboardingQuestions = useSelector(
    (state: RootState) => state.onboarding.questions
  )
  const question = onboardingQuestions[index]
  const isLast = index === onboardingQuestions.length - 1
  return (
    <>
      <OnboardingHeader
        currentStep={index}
        totalSteps={onboardingQuestions.length - 1}
      />
      <OnboardingContainer>
        <TitleDescription
          title={question.title}
          description={question.description}
        />
        <OnboardingFooter
          onSubmit={onSubmit}
          submitText={t('continue')}
          submitting={submitting}
          isLastStep={isLast}
        />
      </OnboardingContainer>
      <div
        data-testid="onboarding-flow-test-hidden"
        data-onboarding-flow-test-type={'info'}
        data-onboarding-flow-test-index={index}
        data-onboarding-flow-test-id={question.friendlyID}
        data-onboarding-flow-test-islast={isLast}
        style={{ display: 'none' }}
      />
    </>
  )
}

export default InfoQuestion
